import React from 'react';
import {Form, Input, Select, Col, Row, InputNumber, message, DatePicker, Radio, Tree} from 'antd';
import ModalDom from '../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {
    dicClrgRuleType,
    commonIsMap, dicExecutionSequenceType, dicExecutionCycle, wftSignType
} from '../../../../axios/dictionaries';
import moment from 'moment';
import DetailTitle from "../../../../components/DetailTitle";
import {
    API_Merchant_findWftPayChannelConfigAll,
} from "../../../../axios/config";
import {formatTime} from "../../../../utils";
const { TextArea } = Input;
const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "编辑分账规则",
            radioLessReliefTypeValue: false,
            wftPayChannelList: [],//威富通支付渠道
            merchantData: [],
            buildingData: [],
            selectUpperLimitValue: false,
            data: {},
        }
    }




    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="支付渠道">
                                    {getFieldDecorator('wftPayChannelConfigId', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.wftPayChannelConfigId
                                    })(
                                        <Select   placeholder="请选择支付渠道"  showSearch  optionFilterProp={'children'}>
                                            {this.state.wftPayChannelList.map(e => (
                                                <Select.Option key={e.id} value={e.id}>{e.projectName}</Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="威富通商户号">
                                    {getFieldDecorator('mchId', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.mchId
                                    })(
                                        <Input
                                            placeholder={'请输入商户号'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="费用类型">
                                    {getFieldDecorator('clrgRuleType', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.clrgRuleType
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择费用类型"
                                            optionFilterProp={'children'}
                                        >
                                            {dicClrgRuleType.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="应汇集金额">
                                    {getFieldDecorator('totalMoney', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.totalMoney
                                    })(
                                        <InputNumber
                                            placeholder={'请输入应汇集金额'}
                                            autoComplete={'off'}
                                            min ={0}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="执行周期">
                                    {getFieldDecorator('executionCycle', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.executionCycle
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择执行周期"
                                            optionFilterProp={'children'}
                                        >
                                            {dicExecutionCycle.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="执行顺序">
                                    {getFieldDecorator('executionSequence', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.executionSequence
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择执行顺序"
                                            optionFilterProp={'children'}
                                        >
                                            {dicExecutionSequenceType.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="周期开始日期">
                                    {getFieldDecorator("startDate", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "请选择开始日期",
                                            },
                                        ],
                                        initialValue: data.startDate?moment(data.startDate):null
                                    })(<DatePicker placeholder="开始日期" />)}
                                </CustomCol>
                                <CustomCol  label="周期结束日期">
                                    {getFieldDecorator("endDate", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "请选择结束日期",
                                            },
                                        ],
                                        initialValue:  data.endDate?moment(data.endDate):null
                                    })(<DatePicker placeholder="结束日期" />)}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="汇集开始日期" required={false}>
                                    {getFieldDecorator("collectionStartDate", {
                                        rules: [
                                            {
                                                required: false,
                                                message: "请选择汇集开始日期",
                                            },
                                        ],
                                        initialValue:  data.collectionStartDate?moment(data.collectionStartDate):null
                                    })(<DatePicker placeholder="截止日期" />)}
                                </CustomCol>
                                <CustomCol  label="汇集截止日期" required={false}>
                                    {getFieldDecorator("collectionEndDate", {
                                        rules: [
                                            {
                                                required: false,
                                                message: "请选择汇集截止日期",
                                            },
                                        ],
                                        initialValue:  data.collectionEndDate?moment(data.collectionEndDate):null
                                    })(<DatePicker placeholder="截止日期" />)}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="允许超出上限">
                                    {getFieldDecorator('upperLimit', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.upperLimit || 2
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            onChange={this.handleUpperLimitChange}
                                        >
                                            {commonIsMap.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}

                                </CustomCol>
                                {this.state.selectUpperLimitValue?
                                    <CustomCol label="上限金额">
                                        {getFieldDecorator('upperLimitMoney', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.upperLimitMoney
                                        })(
                                            <InputNumber
                                                placeholder={'请输入上限金额'}
                                                autoComplete={'off'}
                                                min={0}
                                            />
                                        )}
                                    </CustomCol>:null
                                }
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="支付签名方式">
                                    {getFieldDecorator('signType', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.signType
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            onChange={(e) => this.handleFormChange({signType: e})}
                                        >
                                            {wftSignType.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            {
                                data.signType==='MD5'?
                                    <CustomRow divider>
                                        <CustomCol label="MD5_Key" required={true} labelStyle={{height: '60px'}}
                                                   colStyle={{width: '500px', height: '60px'}}>
                                            {getFieldDecorator('md5Key', {
                                                initialValue: data.md5Key
                                            })(
                                                <TextArea style={{height: '100%', padding: '11px', lineHeight: '20px'}}/>
                                            )}
                                        </CustomCol>
                                    </CustomRow>:null
                            }
                            {
                                data.signType === 'RSA_1_256' ?
                                    <CustomRow divider>
                                        <CustomCol label="RSA_私钥" required={true} labelStyle={{height: '60px'}}
                                                   colStyle={{width: '500px', height: '60px'}}>
                                            {getFieldDecorator('mchPrivateKey', {
                                                initialValue: data.mchPrivateKey
                                            })(
                                                <TextArea
                                                    style={{height: '100%', padding: '11px', lineHeight: '20px'}}/>
                                            )}
                                        </CustomCol>
                                    </CustomRow>:null
                            }
                            {
                                data.signType === 'RSA_1_256' ?
                                    <CustomRow divider>
                                        <CustomCol label="RSA_公钥" required={true} labelStyle={{height: '60px'}}
                                                   colStyle={{width: '500px', height: '60px'}}>
                                            {getFieldDecorator('platPublicKey', {
                                                initialValue: data.platPublicKey
                                            })(
                                                <TextArea
                                                    style={{height: '100%', padding: '11px', lineHeight: '20px'}}/>
                                            )}
                                        </CustomCol>
                                    </CustomRow>:null
                            }
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }


    handleCancel = () => { //关闭页面
        this.props.handleCancel();

        this.setState({ data: {}, loading: false, title: "新增支付渠道",selectUpperLimitValue:false });
    }

    initPack = () => {
        this.forceUpdate();
        this.postWftPayChannelConfigAll();
    }

    handleFormChange = (data) => {
        console.log("选择的值：" + data.signType);
        this.state.data.signType=data.signType;
    }

    handleUpperLimitChange = (e) => { // 是否开启建行

        const selectUpperLimitValue = e===1?true:false
        this.setState({
            selectUpperLimitValue
        })
    }

    postWftPayChannelConfigAll =() =>{
        post({ url: API_Merchant_findWftPayChannelConfigAll }).then(res => {
            this.setState({ wftPayChannelList: res })
        })
    }



    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "编辑支付渠道" });
        postFrom({ url: config.API_wftPayChannel_getWftPayChannelConfigClrgRuleById+"?id="+id, data: { } }).then(res => {

            this.setState({ data:{ ...res, id },selectUpperLimitValue:(res.upperLimit?res.upperLimit==1:false), loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });


    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {

                this.setState({ loading: true });

                values.merchantId= this.state.merchantId;
                console.log(values);
                if(values.startDate){
                    values.startDate = formatTime(values.startDate, "YYYY-MM-DD");
                }
                if(values.endDate){
                    values.endDate = formatTime(values.endDate, "YYYY-MM-DD");
                }
                if(values.collectionEndDate){
                    values.collectionEndDate = formatTime(values.collectionEndDate, "YYYY-MM-DD");
                }
                if(values.collectionStartDate){
                    values.collectionStartDate = formatTime(values.collectionStartDate, "YYYY-MM-DD");
                }

                this.setState({ loading: true });

                if (values.id) {
                    post({ url: config.API_wftPayChannel_updateWftPayChannelConfigClrgRule, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    post({ url: config.API_wftPayChannel_addWftPayChannelConfigClrgRule, data: values }).then(res => {
                        message.success('新增成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '新增失败');
                        this.setState({ loading: false });
                    })
                }
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/WftPayClrgRule/components/ListAdd/index.js